export function renderFormattingToolbar(container, { onFormatAction }) {
  container.innerHTML = `
    <div class="formatting-toolbar" id="toolbar-root">
      <div class="tool-group">
        <button class="tool-btn-rendered" data-action="task" title="Task Checkbox">
          <span class="render-checkbox-box"></span>
        </button>
        
        <button class="tool-btn-rendered" data-action="math" title="Math Block">
          <span class="render-math-pill">$$</span>
        </button>
        
        <button class="tool-btn-rendered" data-action="code" title="Inline Code">
          <span class="render-code-pill">code</span>
        </button>
        
        <button class="tool-btn-rendered" data-action="highlight" title="Highlight">
          <span class="render-highlight-pill">highlight</span>
        </button>

        <button class="tool-btn-rendered" data-action="project" title="Project Pill">
          <span class="render-project-pill">-> Project</span>
        </button>
        
        <button class="tool-btn-rendered" data-action="heading" title="Heading 1">
          <span class="render-heading-pill">H1</span>
        </button>
      </div>
    </div>
  `;

  container.querySelectorAll('[data-action]').forEach(btn => {
    btn.onmousedown = (e) => {
      e.preventDefault();
      if (navigator.vibrate) navigator.vibrate(8);
      const actionType = btn.getAttribute('data-action');
      if (onFormatAction) onFormatAction(actionType);
    };
  });
}
